module.exports = __webpack_public_path__ + "static/event-placeholder-2b20f284e13733eb9ed23f8bd0cfa3d6.png";